/* =========================================================
   ExamCart Blog Tools
   Article ke normal editor mein yeh codes likho (HTML mode ki zaroorat nahi):

   [ec-share]
   [ec-share | apps=whatsapp,telegram,copy | style=icon | title=Dosto ko bhejein]

   [ec-download | label=SSC CGL PYQ PDF | url=https://... ]
   [ec-download | label=Syllabus PDF | url=https://... | style=link]

   [ec-button | label=Official notification | url=https://... ]

   Options:
   share    → apps, style (solid|soft|outline|icon), title, align (left|center)
   download → label, url, style (yellow|green|dark|soft|outline|link),
              size (sm|md|lg), icon (download|pdf|link|none), align (left|center|full),
              form (yes|no)
   button   → download jaise hi, bas form nahi khulta
   ========================================================= */
(function () {
  'use strict';

  var CFG = {};
  try {
    var cfgEl = document.getElementById('EcBlogToolsConfig');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {}

  var PAGE_URL = CFG.pageUrl || location.href.split('#')[0];
  var PAGE_TITLE = CFG.pageTitle || document.title;
  var PHONE_KEY = 'ec_lead_phone';

  function enc(v) { return encodeURIComponent(v || ''); }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key) || '';
      localStorage.setItem(key, val);
    } catch (e) { return ''; }
  }

  /* ---------- Icons (simple line icons) ---------- */
  var S = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICONS = {
    whatsapp: S + '<path d="M3.5 20.5l1.3-3.9A8.5 8.5 0 1 1 8 19.6z"/><path d="M9 9.2c.3 2.6 2.2 4.6 4.8 5.2l1.3-1.2 2 .9c-.2 1-1 1.7-2 1.7A6.4 6.4 0 0 1 8.3 9.2c0-1 .7-1.8 1.7-2l.9 2z"/></svg>',
    telegram: S + '<path d="M21.5 3.5L2.5 10.8l6.3 2.2 2.2 6.5 3.3-4 4.7 3.5z"/><path d="M8.8 13l8.7-6"/></svg>',
    facebook: S + '<path d="M7 11v9H4v-9z"/><path d="M7 11l4-7.5c1.5 0 2.5 1 2.2 2.6L12.7 9H19a2 2 0 0 1 2 2.3l-1.2 6.6A2.5 2.5 0 0 1 17.3 20H7"/></svg>',
    x: S + '<path d="M5 4l14 16"/><path d="M19 4L5 20"/></svg>',
    linkedin: S + '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M3 13h18"/></svg>',
    copy: S + '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg>',
    tick: S + '<path class="ec-ico-tick" d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    native: S + '<circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="M8.3 10.8l7.4-4.3M8.3 13.2l7.4 4.3"/></svg>',
    download: S + '<g class="ec-ico-drop"><path d="M12 3.5v11"/><path d="M7.5 10.5L12 15l4.5-4.5"/></g><path d="M4 16.5v2A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5v-2"/></svg>',
    pdf: S + '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><g class="ec-ico-drop"><path d="M12 11v6"/><path d="M9.5 14.5L12 17l2.5-2.5"/></g></svg>',
    link: S + '<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1"/></svg>',
    close: S + '<path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  /* ---------- Share ---------- */
  var APPS = {
    whatsapp: { label: 'WhatsApp', url: function (u, t) { return 'https://wa.me/?text=' + enc(t + '\n' + u); } },
    telegram: { label: 'Telegram', url: function (u, t) { return 'https://t.me/share/url?url=' + enc(u) + '&text=' + enc(t); } },
    facebook: { label: 'Facebook', url: function (u) { return 'https://www.facebook.com/sharer/sharer.php?u=' + enc(u); } },
    x: { label: 'X', url: function (u, t) { return 'https://twitter.com/intent/tweet?url=' + enc(u) + '&text=' + enc(t); } },
    linkedin: { label: 'LinkedIn', url: function (u) { return 'https://www.linkedin.com/sharing/share-offsite/?url=' + enc(u); } },
    copy: { label: 'Copy link' },
    native: { label: 'More' }
  };
  var ALIASES = { wa: 'whatsapp', whatsap: 'whatsapp', tg: 'telegram', fb: 'facebook', twitter: 'x', li: 'linkedin', more: 'native', all: '*' };

  function parseApps(str) {
    var list = String(str || CFG.shareApps || 'whatsapp,telegram,facebook,x,copy,native')
      .toLowerCase().split(/[\s,]+/).map(function (a) { return ALIASES[a] || a; }).filter(Boolean);
    if (list.indexOf('*') > -1) list = ['whatsapp', 'telegram', 'facebook', 'x', 'linkedin', 'copy', 'native'];
    return list.filter(function (a, i) {
      if (!APPS[a] || list.indexOf(a) !== i) return false;
      if (a === 'native' && !navigator.share) return false;
      return true;
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve) {
      var tmp = document.createElement('textarea');
      tmp.value = text;
      tmp.setAttribute('readonly', '');
      tmp.style.position = 'fixed';
      tmp.style.opacity = '0';
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(tmp);
      resolve();
    });
  }

  function buildShare(opts) {
    var style = (opts.style || CFG.shareStyle || 'solid').toLowerCase();
    if (['solid', 'soft', 'outline', 'icon'].indexOf(style) < 0) style = 'solid';
    var block = document.createElement('div');
    block.className = 'ec-sc ec-sc--block ec-share-block ec-share--' + style + (opts.bare ? ' ec-share-block--bare' : '');
    if (opts.align === 'center') block.style.justifyItems = 'center';

    if (opts.title) {
      var h = document.createElement('span');
      h.className = 'ec-share-block__title';
      h.textContent = opts.title;
      block.appendChild(h);
    }
    var list = document.createElement('div');
    list.className = 'ec-share-block__list';
    if (opts.align === 'center') list.style.justifyContent = 'center';
    block.appendChild(list);

    parseApps(opts.apps).forEach(function (key, i) {
      var app = APPS[key];
      var el;
      if (app.url) {
        el = document.createElement('a');
        el.href = app.url(PAGE_URL, PAGE_TITLE);
        el.target = '_blank';
        el.rel = 'noopener';
      } else {
        el = document.createElement('button');
        el.type = 'button';
      }
      el.className = 'ec-sbtn ec-sbtn--' + key;
      el.style.setProperty('--i', i);
      el.setAttribute('aria-label', (key === 'copy' || key === 'native') ? app.label : 'Share on ' + app.label);
      el.innerHTML = ICONS[key] + '<span class="ec-sbtn__label">' + app.label + '</span>';

      el.addEventListener('click', function (e) {
        track('ec_share', { share_app: key, page_url: PAGE_URL });
        if (key === 'copy') {
          e.preventDefault();
          copyText(PAGE_URL).then(function () {
            el.classList.add('is-done');
            el.innerHTML = ICONS.tick + '<span class="ec-sbtn__label">Link copied</span>';
            setTimeout(function () {
              el.classList.remove('is-done');
              el.innerHTML = ICONS.copy + '<span class="ec-sbtn__label">' + app.label + '</span>';
            }, 2200);
          });
        } else if (key === 'native') {
          e.preventDefault();
          navigator.share({ title: PAGE_TITLE, url: PAGE_URL }).catch(function () {});
        }
      });
      list.appendChild(el);
    });

    animateIn(block);
    return block;
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.3 }) : null;

  function animateIn(block) {
    if (!io || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    block.classList.add('is-armed');
    setTimeout(function () { io.observe(block); }, 0);
  }

  /* ---------- Download / link buttons ---------- */
  var STYLES = ['yellow', 'green', 'dark', 'soft', 'outline', 'link'];

  function isPdf(url) { return /\.pdf(\?|#|$)/i.test(url || ''); }

  function buildButton(type, o) {
    var url = (o.url || o.link || '').trim();
    var label = (o.label || o.text || (type === 'download' ? 'Download PDF' : 'Open link')).trim();
    var style = (o.style || (type === 'download' ? 'yellow' : 'dark')).toLowerCase();
    if (STYLES.indexOf(style) < 0) style = 'yellow';
    var size = (o.size || 'md').toLowerCase();
    var align = (o.align || 'left').toLowerCase();
    var icon = (o.icon || (type === 'download' ? (isPdf(url) ? 'pdf' : 'download') : 'link')).toLowerCase();
    var useForm = type === 'download' && CFG.leadEnabled !== false && String(o.form || 'yes').toLowerCase() !== 'no';

    var a = document.createElement('a');
    a.className = 'ec-dl ec-dl--' + style + ' ec-dl--' + size + (align === 'full' ? ' ec-dl--full' : '');
    a.href = url || '#';
    if (url && !/^\/(?!\/)/.test(url)) { a.target = '_blank'; a.rel = 'noopener'; }
    a.innerHTML = (icon !== 'none' && ICONS[icon] ? ICONS[icon] : '') + '<span></span>';
    a.lastChild.textContent = label;

    if (!url) {
      a.setAttribute('aria-disabled', 'true');
      a.title = 'Link missing';
    }

    a.addEventListener('click', function (e) {
      if (!url) { e.preventDefault(); return; }
      if (useForm) {
        e.preventDefault();
        openLead({ label: label, url: url, trigger: a });
      } else {
        track('ec_link_click', { link_label: label, link_url: url, page_url: PAGE_URL });
      }
    });

    var wrap = document.createElement('span');
    wrap.className = 'ec-sc ec-dl-wrap' + (align === 'center' ? ' ec-dl-wrap--center' : '');
    wrap.appendChild(a);
    return wrap;
  }

  /* ---------- Lead popup ---------- */
  var modal, current;

  function cleanPhone(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    return d;
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'ec-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'EcLeadTitle');
    modal.innerHTML =
      '<div class="ec-modal__backdrop" data-ec-close></div>' +
      '<div class="ec-modal__panel">' +
        '<button type="button" class="ec-modal__close" data-ec-close aria-label="Close">' + ICONS.close + '</button>' +
        '<div class="ec-modal__step" data-step="form">' +
          '<div class="ec-modal__icon">' + ICONS.download + '</div>' +
          '<h2 class="ec-modal__title" id="EcLeadTitle"></h2>' +
          '<p class="ec-modal__file" data-ec-file></p>' +
          '<p class="ec-modal__sub" data-ec-sub></p>' +
          '<form novalidate>' +
            '<label for="EcLeadPhone">Mobile number</label>' +
            '<div class="ec-phone"><span>+91</span>' +
              '<input id="EcLeadPhone" name="phone" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="14" placeholder="10-digit mobile number" required>' +
            '</div>' +
            '<p class="ec-modal__prefill" data-ec-prefill hidden>We have filled in the number you used last time. You can change it.</p>' +
            '<p class="ec-modal__err" role="alert" hidden></p>' +
            '<button type="submit" class="ec-dl ec-dl--yellow ec-dl--lg ec-dl--full">' + ICONS.download + '<span>Download now</span></button>' +
            '<p class="ec-modal__fine" data-ec-note></p>' +
          '</form>' +
        '</div>' +
        '<div class="ec-modal__step ec-modal__done" data-step="done" hidden>' +
          '<div class="ec-modal__icon">' + ICONS.tick + '</div>' +
          '<h2 class="ec-modal__title">Your download has started</h2>' +
          '<p class="ec-modal__sub" data-ec-done-text>If the file didn\'t open, use the button below.</p>' +
          '<a class="ec-dl ec-dl--dark ec-dl--full" data-ec-file-link target="_blank" rel="noopener">' + ICONS.download + '<span>Open file</span></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-ec-close]')) closeLead();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') closeLead();
      if (!modal.hidden && e.key === 'Tab') trapFocus(e);
    });

    var input = modal.querySelector('input');
    input.addEventListener('input', function () {
      modal.querySelector('.ec-phone').classList.remove('is-error');
      modal.querySelector('.ec-modal__err').hidden = true;
    });
    modal.querySelector('form').addEventListener('submit', submitLead);
    modal.querySelector('[data-ec-file-link]').addEventListener('click', function () {
      track('ec_download_open', { link_label: current && current.label, page_url: PAGE_URL });
    });
  }

  function trapFocus(e) {
    var f = modal.querySelectorAll('.ec-modal__step:not([hidden]) a, .ec-modal__step:not([hidden]) button, .ec-modal__step:not([hidden]) input, .ec-modal__close');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openLead(item) {
    if (!modal) buildModal();
    current = item;
    modal.querySelector('#EcLeadTitle').textContent = CFG.leadTitle || 'Download free PDF';
    modal.querySelector('[data-ec-file]').textContent = item.label;
    modal.querySelector('[data-ec-sub]').textContent = CFG.leadText || 'Enter your mobile number and your download will start right away.';
    var note = modal.querySelector('[data-ec-note]');
    note.textContent = CFG.leadNote || '';
    note.hidden = !CFG.leadNote;

    modal.querySelector('[data-step="form"]').hidden = false;
    modal.querySelector('[data-step="done"]').hidden = true;
    modal.querySelector('.ec-modal__err').hidden = true;
    modal.querySelector('.ec-phone').classList.remove('is-error');

    var saved = store(PHONE_KEY);
    var input = modal.querySelector('input');
    input.value = saved;
    modal.querySelector('[data-ec-prefill]').hidden = !saved;

    modal.hidden = false;
    document.body.classList.add('ec-modal-open');
    setTimeout(function () {
      if (saved) modal.querySelector('form button[type="submit"]').focus();
      else input.focus();
    }, 60);
    track('ec_download_popup', { link_label: item.label, page_url: PAGE_URL });
  }

  function closeLead() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('ec-modal-open');
    if (current && current.trigger) current.trigger.focus();
  }

  function submitLead(e) {
    e.preventDefault();
    var input = modal.querySelector('input');
    var phone = cleanPhone(input.value);
    var err = modal.querySelector('.ec-modal__err');

    if (!/^[6-9]\d{9}$/.test(phone)) {
      err.textContent = 'Enter a valid 10-digit mobile number starting with 6, 7, 8 or 9.';
      err.hidden = false;
      modal.querySelector('.ec-phone').classList.add('is-error');
      input.focus();
      return;
    }

    /* OTP verify yahan aayega (abhi band hai) */

    store(PHONE_KEY, phone);
    var lead = {
      phone: '+91' + phone,
      link_label: current.label,
      link_url: current.url,
      page_title: PAGE_TITLE,
      page_url: PAGE_URL,
      time: new Date().toISOString(),
      device: /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      source: 'examcart-blog'
    };

    /* API yahan judegi (baad mein): lead object ko apne server/WhatsApp API par POST karna
       fetch('https://your-api/lead', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(lead), keepalive: true });
    */
    var sendWa = !!CFG.officeWhatsapp;

    track('ec_download_lead', { link_label: current.label, link_url: current.url, page_url: PAGE_URL });

    var fileLink = modal.querySelector('[data-ec-file-link]');
    fileLink.href = current.url;
    modal.querySelector('[data-step="form"]').hidden = true;
    modal.querySelector('[data-step="done"]').hidden = false;

    if (sendWa) {
      var msg =
        '*Download request - ExamCart Blog*\n' +
        'Mobile: +91 ' + phone + '\n' +
        'File: ' + current.label + '\n' +
        'File link: ' + current.url + '\n' +
        'Page: ' + PAGE_TITLE + '\n' +
        'Page link: ' + PAGE_URL;
      modal.querySelector('[data-ec-done-text]').textContent =
        'Send the WhatsApp message and our team will get in touch with you. You can open your file here:';
      window.open('https://wa.me/' + CFG.officeWhatsapp + '?text=' + enc(msg), '_blank', 'noopener');
    } else {
      modal.querySelector('[data-ec-done-text]').textContent = "If the file didn't open, use the button below.";
      window.open(current.url, '_blank', 'noopener');
    }
    fileLink.focus();
  }

  /* ---------- Shortcode parsing ---------- */
  /* Copy-paste se aane wale chhupe characters (zero-width space, nbsp, full-width brackets, alag dash) saaf karo */
  function norm(t) {
    return String(t || '')
      .replace(/[​-‍⁠﻿­]/g, '')
      .replace(/[   ]/g, ' ')
      .replace(/［/g, '[').replace(/］/g, ']')
      .replace(/｜|│|¦/g, '|');
  }
  function scRegex() { return /\[\s*ec\s*[-‐-―]\s*(share|download|button|link)\b([^\]]*)\]/gi; }

  function parseAttrs(str) {
    var o = {};
    norm(str).split('|').forEach(function (part) {
      part = part.trim();
      if (!part) return;
      var i = part.indexOf('=');
      if (i < 0) { o[part.toLowerCase()] = true; return; }
      o[part.slice(0, i).trim().toLowerCase()] = part.slice(i + 1).trim().replace(/^["'“”‘’]+|["'“”‘’]+$/g, '');
    });
    return o;
  }

  function build(type, attrs) {
    if (type === 'share') {
      return buildShare({ apps: attrs.apps, style: attrs.style, title: attrs.title, align: attrs.align, bare: !attrs.title });
    }
    return buildButton(type === 'download' ? 'download' : 'button', attrs);
  }

  var INLINE = { A: 1, SPAN: 1, STRONG: 1, B: 1, EM: 1, I: 1, U: 1, FONT: 1, MARK: 1, SMALL: 1, SUB: 1, SUP: 1, S: 1 };

  function hasFull(text) { return scRegex().test(norm(text)); }

  function rebuild(el) {
    var txt = norm(el.textContent);
    var frag = document.createDocumentFragment();
    var re = scRegex(), last = 0, m, onlyCodes = true;
    while ((m = re.exec(txt))) {
      var before = txt.slice(last, m.index);
      if (before.trim()) { frag.appendChild(document.createTextNode(before)); onlyCodes = false; }
      frag.appendChild(build(m[1].toLowerCase(), parseAttrs(m[2])));
      last = re.lastIndex;
    }
    var after = txt.slice(last);
    if (after.trim()) { frag.appendChild(document.createTextNode(after)); onlyCodes = false; }

    if (!el.parentNode) return;
    if (el.tagName === 'PRE' || el.tagName === 'CODE' || el.tagName === 'BLOCKQUOTE') {
      /* Code block ke roop mein paste hua – normal block bana do */
      var box = document.createElement('div');
      box.className = 'ec-sc-line';
      box.appendChild(frag);
      el.parentNode.replaceChild(box, el);
    } else if (INLINE[el.tagName]) {
      el.parentNode.replaceChild(frag, el);
    } else {
      el.textContent = '';
      el.appendChild(frag);
      if (onlyCodes && el.tagName === 'P') el.classList.add('ec-sc-line');
    }
  }

  function processShortcodes(root) {
    if (!root || !hasFull(root.textContent)) return 0;
    var targets = [];
    Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
      if (el.closest('.ec-sc') || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(el.tagName)) return;
      if (!hasFull(el.textContent)) return;
      var childHas = Array.prototype.some.call(el.children, function (ch) { return hasFull(ch.textContent); });
      if (childHas) return;
      /* Agar code <pre>/<code>/<blockquote> ke andar hai toh poora block badlo */
      var wrapper = el.closest('pre') || el.closest('code') || null;
      if (wrapper && root.contains(wrapper)) el = wrapper;
      if (targets.indexOf(el) < 0) targets.push(el);
    });
    targets.forEach(function (el) { if (el.isConnected) rebuild(el); });
    return targets.length;
  }

  /* ---------- Start ---------- */
  var ROOTS = '[data-ec-content], .article-template__content, .article__content, .ec-article__content';

  function init() {
    var all = Array.prototype.slice.call(document.querySelectorAll(ROOTS));
    var roots = all.filter(function (r) {
      return !all.some(function (o) { return o !== r && o.contains(r); });
    });
    var made = 0;
    roots.forEach(function (r) { made += processShortcodes(r); });
    document.querySelectorAll('[data-ec-share-slot]').forEach(function (slot) {
      if (slot.childElementCount) return;
      slot.appendChild(buildShare({
        apps: slot.getAttribute('data-apps'),
        style: slot.getAttribute('data-style'),
        title: slot.getAttribute('data-title')
      }));
    });
    window.ECBlogTools.found = made;
  }

  window.ECBlogTools = { version: '1.2', process: processShortcodes, openLead: openLead, buildShare: buildShare, buildButton: buildButton };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
